import React, { useEffect, useRef, useState } from 'react';
import Icon from '@/components/Icon';

/**
 * Чип-фильтр одиночного выбора. Стиль `.chip` + `.menu` как везде в проекте.
 *
 * Props:
 *   label   — текст «Статус», «Учитель» и т.п.
 *   value   — текущее значение (string | number | '')
 *   options — [{ v, label }]
 *   onChange(v)
 *   placeholder — текст когда value пустой (по умолчанию «Любой»)
 *   nullLabel  — лейбл для опции «сбросить» в меню (по умолчанию «Любой»)
 *   minMenuWidth — минимальная ширина выпадающего меню
 */
export default function SingleFilterChip({
  label, value, options, onChange,
  placeholder = 'Любой',
  nullLabel   = 'Любой',
  minMenuWidth = 200,
}) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const close = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', close);
    return () => document.removeEventListener('mousedown', close);
  }, []);

  const isActive = value !== '' && value !== null && value !== undefined;
  const current  = isActive ? options.find((o) => String(o.v) === String(value)) : null;
  const summary  = isActive ? (current ? current.label : '?') : placeholder;

  return (
    <div className="chip-wrap" ref={ref}>
      <button
        type="button"
        className={'chip' + (isActive ? ' is-active' : '')}
        onClick={() => setOpen((o) => !o)}
      >
        <span className="chip__label">{label}</span>
        <span className="chip__sep">:</span>
        <span className="chip__value" style={!isActive ? { color: 'var(--fg-faint)' } : undefined}>
          {summary}
        </span>
        <Icon name="chevronDown" size={10} />
      </button>
      {open && (
        <div
          className="menu"
          style={{
            minWidth:  minMenuWidth,
            maxHeight: 360,        /* длинные списки не должны вылезать за экран */
            overflowY: 'auto',     /* появится свой scroll */
          }}
        >
          <button
            type="button"
            className={'menu__item' + (!isActive ? ' is-active' : '')}
            onClick={() => { onChange(''); setOpen(false); }}
          >
            <span style={{ color: 'var(--fg-muted)' }}>{nullLabel}</span>
            {!isActive && <Icon name="check" size={12} />}
          </button>
          {options.map((o) => {
            const active = String(o.v) === String(value);
            return (
              <button
                key={o.v}
                type="button"
                className={'menu__item' + (active ? ' is-active' : '')}
                onClick={() => { onChange(o.v); setOpen(false); }}
              >
                <span>{o.label}</span>
                {active && <Icon name="check" size={12} />}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}
